import styled from "styled-components";

export default c => styled(c)`
  .uuid-text {
    font-family: monospace;
  }
`;



// WEBPACK FOOTER //
// ./src/components/app/registration/device/list/device/style.js